/* A dialog over the screen. Escape closes it, so a carer is never stuck in one. */
import { useEffect } from 'react';

export function Overlay({ children, onClose }: { children: React.ReactNode; onClose: () => void }) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="overlay" role="dialog" aria-modal="true">
      <div className="overlay-inner">{children}</div>
    </div>
  );
}
